import React, { forwardRef, MouseEvent, useCallback } from "react";
import classNames from "classnames/dedupe";
import SvgIcon from "../../Icons/SvgIcon";

export interface IFilterTagData {
  /**
   * Unique Id (value) for render and callback
   */
  id: string;

  /**
   * Text to render in display container
   */
  text: string;

  /** Type of filter (name) */
  category: string;
}

export interface IFilterTag {
  data: IFilterTagData;
  /**
   * Flag if Tag is 'ClearAll' button.
   * Sets custom css class name
   */
  isClearAll?: boolean;

  /**
   * Callback function on when button is clicked
   */
  onClick?: (event: MouseEvent, tag: IFilterTagData) => void;
}

const FilterTag = forwardRef<HTMLButtonElement, IFilterTag>(
  ({ data, isClearAll, onClick }, ref) => {
    const handleClick = useCallback(
      (event) => {
        onClick && onClick(event, data);
      },
      [data, onClick],
    );

    return (
      <button
        ref={ref}
        className={classNames("tagbox tagbox--with-icon", {
          "tagbox--clear": isClearAll,
        })}
        data-testid="filtertag"
        aria-label={data?.text}
        type="button"
        onClick={handleClick}
      >
        <span>{data?.text}</span>
        <SvgIcon data-testid="tag-clear-button" icon="ClearSmallIcon" />
      </button>
    );
  },
);

export default FilterTag;
